import SetPasswordForm from "../../assets/common/SetPasswordForm"
export default function Password(){
    return(
        <SetPasswordForm/>
    )
}